export default __webpack_public_path__ + "static/acc-opening-banner-mobile-fd19e4ec4f82a39dbcef31fde8c6f918.jpg";